import React from 'react'
import Bredcrum from '../../common/Bredcrum'

const TermsConditions = () => {
    return (
        <>

            <Bredcrum
                heading={'Terms & Conditions'}
                path={[
                    { name: 'Terms & Conditions', path: 'terms-and-conditions' },
                ]}
            />

            <div className=' my-5 pb-md-5'>
                <div className='auto-container p-md-5 p-4 pb-4' style={{ backgroundColor: '#f2f2f2' }}>
                    <div className="row">
                        {/* <div className="sec-title">
                            <h2 className='mb-4'>Terms & Conditions</h2>
                            <p className='d-flex'>
                                <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                By using our driving services, you agree to comply with these terms and conditions. If you do not agree, please refrain from using our services.
                            </p>

                            <h4 className='my-4'>Acceptance of Terms</h4>
                            <p className='mt-3 d-flex'>
                                <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                By using our driving services, you agree to comply with these terms and conditions. If you do not agree, please refrain from using our services.
                            </p>

                            <h4 className='my-4'>Service Availability</h4>
                            <p className='mt-3 d-flex'>
                                <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                Our services are available within designated areas as specified on our website. We reserve the right to modify service availability at any time without prior notice.
                            </p>

                            <h4 className='my-4'>User Responsibilities</h4>
                            <p className='mt-3 d-flex'>
                                <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                Users must provide accurate information when booking a service. You are responsible for any fees incurred due to incorrect details.
                            </p>

                            <h4 className='my-4'>Payment Terms</h4>
                            <p className='mt-3 d-flex'>
                                <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                All payments must be made in advance through our accepted payment methods. Refunds are subject to our cancellation policy as outlined below.
                            </p>

                            <h4 className='my-4'>Cancellation Policy</h4>
                            <p className='mt-3 d-flex'>
                                <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                Cancellations must be made at least 24 hours in advance to qualify for a full refund. Late cancellations may incur a fee as specified in our fee schedule.
                            </p>

                            <h4 className='my-4'>Driver Conduct</h4>
                            <p className='mt-3 d-flex'>
                                <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                Our drivers are expected to maintain a professional demeanor and adhere to all traffic laws. Any misconduct should be reported immediately.
                            </p>

                            <h4 className='my-4'>Liability Limitations</h4>
                            <p className='mt-3 d-flex'>
                                <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                We are not liable for any damages or losses incurred during the use of our services, including delays, accidents, or personal injury, except as required by law.
                            </p>

                            <h4 className='my-4'>Vehicle Condition</h4>
                            <p className='mt-3 d-flex'>
                                <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                All vehicles provided for service are maintained to high safety standards. Users are expected to report any issues immediately to ensure safe travel.
                            </p>

                            <h4 className='my-4'>Changes to Terms</h4>
                            <p className='mt-3 d-flex'>
                                <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                We reserve the right to modify these terms at any time. Continued use of our services after changes constitutes acceptance of the new terms.
                            </p>

                            <h4 className='my-4'>Governing Law</h4>
                            <p className='mt-3 d-flex'>
                                <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                These terms and conditions are governed by the laws of the jurisdiction in which our company operates. Any disputes will be resolved in accordance with local laws.
                            </p>
                        </div> */}
                        <div className="sec-title">
                            <div className="card-body">
                                *Please note that Intensive courses are governed by Additional Ts&amp;Cs at
                                the bottom of this page.
                                <br />
                                <br />
                                <strong className='text-black'>PRELIMINARY NOTE</strong>
                                <br />
                                <br />
                                There’s no escaping it, these Ts&amp;Cs are a legal document….
                                <br />
                                <br />
                                Dry…
                                <br />
                                <br />
                                Boring…
                                <br />
                                <br />
                                But necessary…
                                <br />
                                <br />
                                We know this sort of thing doesn’t make the greatest bedtime reading, so, in
                                order to assist you understanding things, we have provided “In English”
                                summaries of important terms.
                                <br />
                                <br />
                                They appear in italics at the end of each section.
                                <br />
                                <br />
                                Whilst these are designed to aid your understanding, such summaries do not
                                constitute operative parts of this contract and accordingly, do not create
                                legally binding obligations. They are designed solely to improve the reader's
                                comprehension of the legally operative parts of the contract.
                                <br />
                                <br />
                                <h5 className='text-black'>1. Interpretation and application </h5>
                                <div className='ms-3'>
                                    <br />
                                    1.1.In these terms and conditions (the “Conditions”) “We”, “Us” or “Our” means
                                    Precision Driving School and https://precisiondriving.uk/.
                                    <br />
                                    <br />
                                    1.3.“You” or “Your” means you the customer.
                                    <br />
                                    <br />
                                    1.4.You must read these Conditions in full as they set out the complete terms
                                    upon which We have agreed to provide and You have agreed to obtain driving
                                    lesson tuition from Us.
                                    <br />
                                    <br />
                                    1.5.We and Your Driving Instructor reserve the right to charge for any lessons
                                    affected by Your failure to comply with any of these Conditions.
                                    <br />
                                    <br />
                                    In English: We use these terms throughout this Agreement. They are the
                                    important things we have to refer back to a lot. You can easily spot a defined
                                    term as it will start with Capital Letter. This helps keeps things a bit
                                    shorter. We explain who we are and who you are. We reserve the right to charge
                                    for lessons if you don’t comply with these terms (for example if you didn’t
                                    turn up).
                                    <br />
                                    <br />
                                </div>
                                <h5 className='text-black'>2. Driving Lesson Tuition with Precision Driving School</h5>
                                <div className='ms-3'>
                                    <br />
                                    2.1.Precision Driving School offer driving lesson tuition with an Precision
                                    Driving Instructor (“Your Driving Instructor”).
                                    <br />
                                    <br />
                                    In English: We’re a driving school and we give driving lessons (we’re good at
                                    it)
                                    <br />
                                    <br />
                                </div>
                                <h5 className='text-black'>3. Your Driving Instructor</h5>
                                <div className='ms-3'>
                                    <br />
                                    3.1.Your Driving Instructor is one of Our self-employed licensees whose
                                    relationship with Us is governed by a licence agreement. No contractual
                                    liability shall arise or subsist between You and Us. We will endeavour to
                                    assist You with Your requirements. All of Our Driving Instructors are licenced
                                    to carry on business as driving instructors and have obtained such licences
                                    from the Driving Standards Agency, which is an executive agency of the
                                    Department for Transport.
                                    <br />
                                    <br />
                                    In English: Our driving instructors are (awesome) self-employed guys and girls
                                    who operate using our brand. Because they are self-employed, your relationship
                                    is with them, not us directly (we built the driving school and the brand but
                                    they give the lessons). If you have a problem, its best to try and sort it
                                    with the instructor first but we’ll endeavour to help solve it if that doesn’t
                                    work. We make sure all of the instructors are licensed and accordingly give
                                    top quality driving instruction to the highest standards.
                                    <br />
                                    <br />
                                </div>
                                <h5 className='text-black'>4. Lesson Tuition</h5>
                                <div className='ms-3'>
                                    <br />
                                    4.1.Lesson Tuition is only available to persons who meet the following
                                    criteria:
                                    <br />
                                    <br />
                                    4.1.1.Aged 17 or over (or aged 16 if in receipt of the higher rate element of
                                    the disability living allowance); and
                                    <br />
                                    <br />
                                    4.1.2.Who hold a valid UK provisional driving licence (“Licence”); and
                                    <br />
                                    <br />
                                    4.1.3.Who are legally entitled to drive in the UK (this includes making sure
                                    you meet the minimum legal requirements – checking this is the learners
                                    responsibility at all times).
                                    <br />
                                    <br />
                                    4.2Your responsibilities.
                                    <br />
                                    <br />
                                    4.2.1.It is Your responsibility to ensure that You have the appropriate
                                    Licence and the Licence must be presented to Your Driving Instructor prior to
                                    the commencement of Your tuition.
                                    <br />
                                    <br />
                                    4.2.2.Your Instructor reserves the right to refuse to provide You with lesson
                                    tuition or to cancel any lessons You have agreed to or booked, without
                                    liability, if You fail to provide him/her with the Licence prior to Your first
                                    lesson.
                                    <br />
                                    <br />
                                    4.2.3.Your lesson tuition is governed by a contract between You and Your
                                    Instructor. Accordingly, You and Your Instructor are responsible for arranging
                                    the date, time, pick-up location and duration of Your lessons.
                                    <br />
                                    <br />
                                    4.2.4.You will treat Your Instructor with respect and follow Your Instructor’s
                                    reasonable instructions, particularly with regard to matters affecting Your
                                    health and safety or the health and safety of others.
                                    <br />
                                    <br />
                                    4.3Your Driving Instructor’s responsibility.
                                    <br />
                                    <br />
                                    4.3.1.Provide You with lesson tuition at the hourly rate communicated to You
                                    from time to time;
                                    <br />
                                    <br />
                                    4.3.2.Recommend what are, in their opinion, the most appropriate training
                                    methods and aids to help You study for Your theory and hazard perception test;
                                    <br />
                                    <br />
                                    4.3.3.Design a course of lessons to match Your specific driving and learning
                                    needs from Your first lesson right through to Your practical test;
                                    <br />
                                    <br />
                                    4.3.4.Provide You with lessons which will last one hour or such other duration
                                    as You and Your Instructor will agree in advance;
                                    <br />
                                    <br />
                                    4.3.5.Provide a presentable, modern, properly maintained and dual controlled
                                    car for each lesson;
                                    <br />
                                    <br />
                                    4.3.6.Recommend, where appropriate, advanced courses to help You develop Your
                                    skills for; motorway driving, driving in extreme weather conditions and Pass
                                    Plus;
                                    <br />
                                    <br />
                                    4.3.7.Give You relevant feedback during Your lesson and record Your
                                    development in Your precision “On the Move” training record at the end of each
                                    lesson if you provide it to them and ask them to fill it in for you (it’s your
                                    responsibility o remember to do this) ;
                                    <br />
                                    <br />
                                    4.3.8.Monitor Your progress, advise and recommend what is, in their opinion,
                                    the appropriate time to book Your mock practical test and once it has been
                                    agreed between you both, apply for Your practical driving test and where
                                    required, they will advise whether it should be subsequently rescheduled;
                                    <br />
                                    <br />
                                    4.3.9.Provide training on a one-to-one basis with no other learner in the car;
                                    <br />
                                    <br />
                                    4.3.10.Honour the full time booked for each lesson, which should include an
                                    introduction, practical training and a debrief at the end of Your lesson.
                                    <br />
                                    <br />
                                    4.3.11.At all times conduct themselves in a professional manner including;
                                    <br />
                                    <br />
                                    i.being courteous and considerate to You
                                    <br />
                                    <br />
                                    ii.avoiding physical contact except in an emergency
                                    <br />
                                    <br />
                                    iii.not smoking during Your lessons
                                    <br />
                                    <br />
                                    iv.restricting mobile phone use to emergencies or for Your benefit;
                                    <br />
                                    <br />
                                    4.3.12.Reserve the right to cancel a lesson or finish a lesson early on
                                    grounds of road safety
                                    <br />
                                    <br />
                                    4.3.13.Not discriminate against You and will always abide by the law;
                                    <br />
                                    <br />
                                    4.3.14.Endeavour to be on time at the agreed pick-up point and be available
                                    for the full duration of the lesson booking, subject to any circumstances
                                    beyond their control;
                                    <br />
                                    <br />
                                    4.3.15.Endeavour to give You two working days notice (excluding Bank Holidays)
                                    should a lesson need to be rescheduled;
                                    <br />
                                    <br />
                                    4.3.16.Respond professionally to any worries or issues that You may have and
                                    try to resolve them to Your satisfaction. If requested, they will give You the
                                    name of the Area Director to whom You can refer the matter.
                                    <br />
                                    <br />
                                    4.3.17.If Your Driving Instructor is for whatever reason unable to comply with
                                    their obligations to You, both We and Your Driving Instructor reserve the
                                    right to arrange for an alternative Precision Driving Instructor to provide
                                    You with some or all of Your driving tuition. We will use Our best endeavours
                                    to notify You or the alternative instructor who will provide You with Your
                                    lesson tuition. If We or Your Instructor are unable to arrange for an
                                    alternative Instructor to provide Your lesson tuition, or in the event of a
                                    mechanical breakdown of the vehicle in which You have been learning to drive,
                                    or for any other reason, the Instructor reserves the right to rearrange Your
                                    lessons for a time convenient to both You and the Instructor.
                                    <br />
                                    <br />
                                    In English: This sets out sets out some ground rules. Obviously you need to be
                                    at least 17, have a provisional license and meet the legal eyesight
                                    requirements in order to learn to drive. Your responsibilities and your
                                    driving instructors’ responsibilities are also set out. They’re pretty
                                    straightforward and fair rules.
                                    <br />
                                    <br />
                                </div>
                                <h5 className='text-black'>5. Lesson Cancellation Policy</h5>
                                <div className='ms-3'>

                                    <br />
                                    5.1.You must give Us or Your Instructor at least two working days notice
                                    (excluding Saturdays, Sundays and Bank Holidays) (the “Minimum Notice”) if You
                                    wish to cancel or rearrange a driving lesson, otherwise You will be liable to
                                    pay for 100% of the lesson fee.
                                    <br />
                                    <br />
                                    5.2.Where You have pre-paid for any lesson but fail to attend or provide the
                                    Minimum Notice to cancel or rearrange the lesson, it will be counted as a
                                    lesson taken for the purposes of the lesson cancellation policy and You will
                                    be liable for the lesson fee.
                                    <br />
                                    <br />
                                    5.3.You will not be able to sell or transfer any driving lessons which You
                                    have pre-paid for to any third party, without obtaining Our prior written
                                    consent.
                                    <br />
                                    <br />
                                    In English: We need 2 days notice if you are going to cancel a lesson. Our
                                    instructors rely upon you turning up for a lesson you’ve committed to. It’s
                                    how they earn a living. 2 days is the minimum period within which we have a
                                    realistic chance of finding them a different pupil to fill a lesson. Any
                                    shorter than that and they may miss out. Because of this, we charge for a
                                    cancelled lesson if you give us less than 2 days notice to cancel it. We hope
                                    you agree that’s fair.
                                    <br />
                                    <br />
                                </div>
                                <h5 className='text-black'>6. Insurance</h5>
                                <div className='ms-3'>
                                    <br />
                                    6.1.Your Instructor will carry the appropriate motor insurance and be able to
                                    provide such documentation, should You be involved in an accident, whilst
                                    under the supervision of Your Instructor.
                                    <br />
                                    <br />
                                    In English: All of our instructors are insured to give driving lessons.
                                    <br />
                                    <br />
                                </div>
                                <h5 className='text-black'> 7. Price Changes</h5>
                                <div className='ms-3'>
                                    <br />
                                    7.1.We reserve the right to change the price of all Our learner driver
                                    products including all Lessons, at any time.
                                    <br />
                                    <br />
                                    In English: We may need to change our prices. This is because things can get
                                    more expensive. Petrol or diesel goes up etc. We try not to do this too often
                                    but have to let you know it might happen.
                                    <br />
                                    <br />
                                </div>
                                <h5 className='text-black'>8. Non-Block Booked Tuition</h5>
                                <div className='ms-3'>
                                    <br />
                                    8.1.The price of lessons that have not been pre-paid may be changed at any
                                    time. You will receive prior notice of any price increases.
                                    <br />
                                    <br />
                                    In English: We can change the price of lessons if they’ve not been pre-paid
                                    for the above reasons. We try not to do this and will always give you advance
                                    notice. If you want a guaranteed price, block book your lessons (see below)
                                    <br />
                                    <br />
                                </div>
                                <h5 className='text-black'>9. Block Booked Tuition</h5>
                                <div className='ms-3'>

                                    <br />
                                    9.1.The cost of Block Booked tuition is based on the lesson price in force at
                                    the time that the booking is made and will be honoured for a period of 9
                                    months from the date of the booking. We reserve the right to increase the
                                    price of any unused tuition time.
                                    <br />
                                    <br />
                                    In English: If you block book lessons, you fix the price for 9 months. We have
                                    to set realistic limits on the length of time you can lock in a price to stop
                                    your Gran booking your driving lessons 17 years in advance…. 9 months seemed
                                    fair.
                                    <br />
                                    <br />
                                </div>
                                <h5 className='text-black'>10. Special Offers</h5>
                                <div className='ms-3'>
                                    <br />
                                    10.1.We also reserve the right to introduce (and to withdraw) offers from time
                                    to time in respect of both Our driving tuition together with any other
                                    products that We may decide.
                                    <br />
                                    <br />
                                    10.2.Such offers will not affect the price of Block Bookings unless it is
                                    expressly stated within the offer.
                                    <br />
                                    <br />
                                    10.3.These terms and conditions shall apply to the special offers, in each of
                                    the particular ‘terms of the offer’, which shall be published on the Website
                                    https://precisiondriving.uk/
                                    <br />
                                    <br />
                                    In English: We make offers from time to time. We may have to withdraw them.
                                    However, they’re often replaced. If you want to take up an offer, the best
                                    advice is to act quickly to make sure you bag it!
                                    <br />
                                    <br />
                                </div>
                                <h5 className='text-black'>11. Payment</h5>
                                <div className='ms-3'>
                                    <br />
                                    11.1.You must pay for Your product(s), good(s) or lesson(s) in advance using
                                    the following methods:
                                    <br />
                                    <br />
                                    11.1.1.payment via credit or debit card by telephoning Our Customer Service
                                    Contact Centre on 0116 286 5577.
                                    <br />
                                    <br />
                                    11.1.2.payment via credit or debit card online at Precision Driving School
                                    <br />
                                    <br />
                                    11.1.3.payment via cheque made payable to Your Instructor’s agent,
                                    “https://precisiondriving.uk/” (“Agent”).
                                    <br />
                                    <br />
                                    11.1.4.You can send cheques to one of the following addresses or give them to
                                    Your Instructor,
                                    <br />
                                    <br />
                                    i.For England &amp; Wales tuition: 15-17 Leicester Road, Narborough, Leicester
                                    LE19 2HL
                                    <br />
                                    <br />
                                    ii.For Northern Ireland tuition: Adelaide House, 1 Falcon Road, Belfast. BT12
                                    6SJ
                                    <br />
                                    <br />
                                    In English: These are the ways you can pay us for your lessons and other
                                    things from us. We take most normal methods of payments (we draw the line at
                                    magic beans and IOUs though).
                                    <br />
                                    <br />
                                </div>
                                <h5 className='text-black'>12. Acknowledgement</h5>
                                <div className='ms-3'>
                                    <br />
                                    12.1.Where You make any payments directly to Your Instructor or any of Our
                                    Instructors and the Instructor fails to pass on such payments to Us, neither
                                    We nor the Agent will be liable for any shortfalls in such payments or any
                                    missing payments or any other failure on the part of the Instructors to
                                    forward such payments on to the Agents or Us and You acknowledge that You will
                                    at all times be liable for any payments that remain outstanding to Us.
                                    <br />
                                    <br />
                                    12.2.Further, You acknowledge that it is Your responsibility to ask for and to
                                    obtain appropriate receipts or other proofs, in relation to all payments You
                                    make to Your Instructor or any of Our Instructors. Where We are able to, We
                                    will endeavour to assist with any discrepancies in payments You have made
                                    without ever accepting liability for the same. Subject to You having
                                    sufficient funds, all online payments that You make will be shown on Your
                                    precision account within 24 hours of being made. Payments made using other
                                    methods, may take longer to be credited into Your precision account.
                                    <br />
                                    <br />
                                    12.3.We do not accept responsibility or liability for any payments however
                                    made, being lost, delayed, misappropriated, rejected, tampered with, being
                                    short of the required amount or any overpayment on Your part. It is Your
                                    responsibility to ensure that You have sufficient funds to make all payments
                                    to Us and to ensure that You have paid Us the correct amount.
                                    <br />
                                    <br />
                                    In English: This is an important bit – if you pay your instructor directly and
                                    they don’t tell us, it can create problems and confusion. If they’ve forgotten
                                    to hand money over, spent it on chocolate bars or petrol and forgotten about
                                    it, we’ll have no record on our system. The best (and only) way to avoid this
                                    is to make sure you pay us directly. If you pay us directly, we’ll know about
                                    it and there will be no confusion. We can’t be held liable in the event there
                                    is a dispute and you did not follow these rules. Pay us directly and there
                                    will be no problem.
                                    <br />
                                    <br />
                                </div>
                                <h5 className='text-black'>13. Refund Policy</h5>
                                <div className='ms-3'>
                                    <br />
                                    13.1.Lesson Tuition
                                    <br />
                                    <br />
                                    13.1.1.In the event that You made a purchase from us without face to face
                                    contact (e.g. over the phone or on our website before you undertook any
                                    lessons) you are entitled to the protection provided by The Consumer Contract
                                    Regulations 2013. Accordingly, you are entitled to cancel a purchase within 14
                                    calendar days of receiving any goods (if applicable) or within 14 calendar
                                    days of receiving durable confirmation comprising the following information: :
                                    <br />
                                    <br />
                                    · our business name and, if we require payment in advance, our postal address;
                                    <br />
                                    <br />
                                    · a description of the goods or services and, if we are supplying them on a
                                    continuing basis, the minimum term;
                                    <br />
                                    <br />
                                    · the price (including taxes) and how long the price and any special offer
                                    will remain valid;
                                    <br />
                                    <br />
                                    · details of any delivery costs;
                                    <br />
                                    <br />
                                    · how payment can be made;
                                    <br />
                                    <br />
                                    · the arrangements for delivery of goods or performance of the service;
                                    <br />
                                    <br />
                                    · information about cancellation rights;
                                    <br />
                                    <br />
                                    · details as to whether we will supply a substitute if the goods or services
                                    are not available (and, if so, in the case of goods confirmation that we will
                                    meet the cost of returning unwanted substitutes);
                                    <br />
                                    <br />
                                    · if the sale is of digital content, additional information about, for
                                    example, its functionality and compatibility;
                                    <br />
                                    <br />
                                    · how You can exercise Your cancellation rights, including whether the
                                    contract requires You to return unwanted goods if they cancel, and who will
                                    pay the costs of returning those goods;
                                    <br />
                                    <br />
                                    · any guarantees or after-sales service provided;
                                    <br />
                                    <br />
                                    · Our geographical address for You to contact Us with any complaints;
                                    <br />
                                    <br />
                                    · for contracts lasting more than one year (or indefinitely), under what
                                    conditions the contract can be cancelled (if applicable).
                                    <br />
                                    <br />
                                    All of this information is provided upon making an order through our website
                                    or over the phone. If You have not taken any lesson(s) within the first 14
                                    days of the date of placing your order / receipt of the above stated durable
                                    confirmation, You will be entitled to a full refund of any amounts paid,
                                    subject to deduction of the Refund Charge (clause 13.1.4)
                                    <br />
                                    <br />
                                    13.1.2.If You have taken lesson(s) within the first 14 days, and You wish to
                                    cancel You will not be eligible for a refund on any lessons taken.
                                    <br />
                                    <br />
                                    13.1.3.No refund is payable where a period of 12 months has lapsed since Your
                                    last lesson.
                                    <br />
                                    <br />
                                    13.1.4.If You are entitled to any refund, You will be required to pay an
                                    administration charge of £30 to process the refund (the “Refund Charge”). The
                                    Refund Charge will be deducted from each refund that is paid back to You.
                                    <br />
                                    <br />
                                    13.1.5.Where it is possible to do so, and We agree to refund You any amounts,
                                    We will do so using the same method You used when You made the payment. If for
                                    any reason We are unable to refund You using the same method with which You
                                    paid, We reserve the right to refund You by any other method We deem
                                    appropriate.
                                    <br />
                                    <br />
                                    13.1.6.We may request additional information from You to confirm Your identity
                                    in order to comply with the Money Laundering Regulations 2007; We will also
                                    use this information to ensure adherence to Our Merchant Operating
                                    Instructions for card collection facilities.
                                    <br />
                                    <br />
                                    13.1.7.Refunds may take up to 28 working days to reach You or Your account.
                                    <br />
                                    <br />
                                    13.2.Learner Driver Products
                                    <br />
                                    <br />
                                    13.2.1.If any of the goods You receive are damaged or faulty on receipt, You
                                    must inform Us within 48 hours of receipt and where it is possible, We will
                                    provide You with replacements of any goods which are faulty or damaged. If We
                                    are unable to replace such goods, We will notify You and You may be entitled
                                    to a refund.
                                    <br />
                                    <br />
                                    13.2.2.You will not be eligible for any refund or replacement of the goods if:
                                    <br />
                                    <br />
                                    a.Any goods that You return to us are in Our opinion used, damaged or not
                                    within their original packaging; or
                                    <br />
                                    <br />
                                    b.You decide You no longer want the goods and do not return them with 10 days
                                    of Your purchase; or
                                    <br />
                                    <br />
                                    c.You fail to inform Us of any faulty or damaged goods within 48 hours of
                                    receiving them.
                                    <br />
                                    <br />
                                    d.Postage and Packaging (P&amp;P) is non-refundable in all cases.
                                    <br />
                                    <br />
                                    In English: This clause sets out your rights to cancel a contract if you
                                    didn’t meet with us face to face when you first made it. It applies to
                                    ordering goods (e.g. books or guides) and services (e.g. driving lessons) over
                                    the phone or internet. It doesn’t apply to any contracts made face to face for
                                    example if you book a further lesson at the end of a lesson face to face with
                                    your instructor, or if you pop into the office to book a lesson.
                                    <br />
                                    <br />
                                </div>
                                <h5 className='text-black'>14. Limitation of Liability</h5>
                                <div className='ms-3'>

                                    <br />
                                    14.1.Neither the Agent nor We have, or shall have any liability to You in
                                    relation to any injury, loss or damage arising from the use of the tuition
                                    vehicle or from the acts or omissions of Your Instructor or any other one of
                                    Our Instructors.
                                    <br />
                                    <br />
                                    14.2.We will not in any event be liable for any losses relating to any
                                    business interests that You may have including but not limited to loss of
                                    profits, business, loss of opportunity or any business interruptions or delays
                                    that You may incur. This does not apply to any claim You may have for personal
                                    injury or death and nothing in these Conditions will affect Your statutory
                                    rights.
                                    <br />
                                    <br />
                                    14.3.We do not guarantee to provide or procure the provision of any of the
                                    services referred to in these Conditions if We are prevented from doing so in
                                    circumstances beyond Our reasonable control, including without limitations,
                                    the activities of civil government authorities, third party industrial
                                    disputes, internal industrial disputes where We have taken reasonable steps to
                                    prevent the effects of such action on any of the services set out in these
                                    Conditions but have been unable to do so; acts of God, or severe weather
                                    conditions We reserve the right to make reasonable changes to the services
                                    referred to in these Conditions and to these Conditions for any reason We deem
                                    necessary.
                                    <br />
                                    <br />
                                    14.4.Where We do make any such changes, We will give You reasonable notice of
                                    the changes. If as a direct result of such changes the services We provide to
                                    You are substantially varied to Your detriment, and where We are satisfied of
                                    the same, You may cancel Your agreement with Us by giving not less than 30
                                    days’ notice in writing to Our address below.
                                    <br />
                                    <br />
                                    14.5.Any refunds that You may be entitled to will be dealt with in accordance
                                    with Our Refund Policy set out above. If any provision of these Conditions is
                                    found by any court, tribunal or administrative body of competent jurisdiction
                                    to be wholly or partly illegal, invalid, void, voidable, unenforceable or
                                    unreasonable it shall to the extent of such illegality, invalidity, voidness,
                                    voidability, unenforceability or unreasonableness, be deemed severable and the
                                    remaining provisions of these Conditions shall continue in full force and
                                    effect..
                                    <br />
                                    <br />
                                    14.6.Informing You about Products and Services. If You decide You do not wish
                                    to receive such information, please inform Us, but be aware that this will
                                    prevent You from receiving Our special offers and/or promotions.
                                    <br />
                                    <br />
                                    14.7. We do not control the DVSA / Test Centres and our instructors are self
                                    employed. Accordingly, we cannot be held responsible for any loss or perceived
                                    loss in the event of a cancelled test.
                                    <br />
                                    <br />
                                    In English: Like all businesses in this day and age, we have to set out some
                                    boundaries for things we cannot be held responsible for. This clause just sets
                                    out what liabilities we accept and don’t accept. We have been trading since
                                    1986 and wouldn’t have lasted this long if we didn’t take things seriously. We
                                    provide great driving tuition and comply with the law, you can be assured of
                                    that. We simply cannot guarantee things such as the weather, your examiner not
                                    being ill on the day of your test etc. We’re fair and trust you will be too.
                                    <br />
                                    <br />
                                </div>
                                <h5 className='text-black'>15. Data Protection</h5>
                                <div className='ms-3'>
                                    <br />
                                    15.1.For the purposes of the Data Protection Act 1998 and the General Data
                                    Protection Regulation 2018, the data controller in relation to the information
                                    You supply is Ability Driving Academy Limited.
                                    <br />
                                    <br />
                                    15.2.We may use the information You provide for administration, marketing,
                                    customer services and profiling Your purchasing preferences. We may also
                                    disclose Your information to Our service providers and agents for these
                                    purposes. If You do not want Us to contact any third parties with this
                                    information, You must notify Us of Your objection within 24 hours of accepting
                                    these Conditions. When You give Us information about another person, You
                                    confirm that they have authorised You to act for them, to consent to the
                                    processing and use of their personal data in the manner described in this
                                    notice and to receive on their behalf any data protection notice.
                                    <br />
                                    <br />
                                    15.3.You have the right to ask for a copy of Your information (for which We
                                    will charge a reasonable fee to cover Our administration costs) and to correct
                                    any inaccuracies contained therein.
                                    <br />
                                    <br />
                                    15.4.We will always handle your data in accordance with the Data Protection
                                    Act 1998 and the General Data Protection Regulation 2018 and our data
                                    protection policy is available upon request.
                                    <br />
                                    <br />
                                    In English: We treat your data seriously. It’s personal to you and we will
                                    only use in order to deliver a top-quality driving tuition service to you. We
                                    operate within the confines of the law and to a policy you can ask to see.
                                    <br />
                                    <br />
                                    resources/views/frontend/terms_condition.blade.php
                                    <br />
                                    <br />
                                </div>
                                <h5 className='text-black'>16. Complaints Procedure</h5>
                                <div className='ms-3'>
                                    <br />
                                    16.1.If You have any concerns or complaints about any part of Your driving
                                    tuition which cannot be resolved with Your Instructor, please contact Head
                                    Office.
                                    <br />
                                    <br />
                                    16.2.Where a customer advisor is unable to resolve Your complaint, You will be
                                    entitled to escalate the matter to Our Customer Care Department by writing to
                                    Customer Care at the address below.
                                    <br />
                                    <br />
                                    16.3.The Customer Care team will use reasonable endeavours to respond to your
                                    written query within 10 working days. Email them at info@precisiondriving.uk
                                    <br />
                                    <br />
                                    16.4.We may record telephone calls for staff training and evidential purposes.
                                    <br />
                                    <br />
                                    16.5.You can send this to one of the following addresses:
                                    <br />
                                    <br />
                                    i.For England &amp; Wales tuition: 15-17 Leicester Road, Narborough, Leicester
                                    LE19 2HL
                                    <br />
                                    <br />
                                    ii.For Northern Ireland tuition: Adelaide House, 1 Falcon Road, Belfast BT12
                                    6SJ
                                    <br />
                                    <br />
                                    In English: We strive to be the best and to avoid any complaints, However, on
                                    occasion things can go wrong. This sets out how, if you are not happy with
                                    something, you let us know so we can make it right if that’s the right thing
                                    to do. We’re honest and we are fair.
                                    <br />
                                    <br />
                                    Intensive Terms &amp; Conditions
                                    <br />
                                    <br />
                                    I understand that I must complete the full course in order to take my
                                    Practical Driving Test and if I do not complete all of my driving lessons my
                                    instructor reserves the right to withdraw his / her services and the use of
                                    the tuition vehicle for my Practical Driving Test.
                                    <br />
                                    <br />
                                    I understand that I must give at least 28 days notice to cancel or re-schedule
                                    my course. The cancellation fee is £150 + any test fees incurred and there is
                                    no refund due once an intensive course has started.
                                    <br />
                                    <br />
                                    I understand that Precision Driving School will make every reasonable effort
                                    to ensure the Practical Driving Test is on or near the last day of the course,
                                    but Precision Driving School accepts no responsibility when this is not
                                    possible due to restrictions or cancellations by the DVSA/DVA.
                                    <br />
                                    <br />
                                    I understand that Precision Driving School cannot apply for a practical
                                    driving test until I have passed my theory test. Precision will endeavour to
                                    obtain the earliest possible date for my practical driving test, but I
                                    understand that this is subject to the availability of practical driving tests
                                    in my area. Should an early date not be available Precision Driving School
                                    will endeavour to seek an earlier date for the test as soon as possible. I
                                    also understand that Driving Test dates quoted at the time of booking the
                                    intensive course may not be available when I have passed my Theory test.`
                                    <br />
                                    <br />
                                    Should your appointed Precision Driving School instructor be unavailable due
                                    to illness or unforeseen circumstances, we will endeavour to find a
                                    replacement intensive driving instructor. In exceptional circumstances where
                                    this may not be possible, we reserve the right to postpone your course and
                                    practical Driving Test.
                                    <br />
                                    <br />
                                    Should you fail your Theory or Practical Driving Test on the first attempt we
                                    will book one further test for you at the earliest opportunity. (This only
                                    applies to the 10 day and 7 day Intensive courses) The use of the tuition
                                    vehicle for the second Practical Driving Test or any additional driving
                                    lessons required are not included in the course fee.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default TermsConditions